import React from 'react'
import PropTypes from 'prop-types'
import NumberField from './Field'
import { minMaxVal, notNegative } from 'helpers/validators'
import { NumberContainer } from './StyledNumber'

const NumberComponent = (props) => {
	const { inline, format, step, ...rest } = props
	const fieldProps = {
		...!props.noForm && {
			...!props.enableNegative && notNegative(), // default validation for positive values
			...format === 'percent' && { ...minMaxVal({ max: 100 }) },
			...format === 'currency' && { precision: 2 }
		},
		...rest
	}
 	return (
	  <NumberContainer inline={inline} withControls={props.withControls}>
			<NumberField {...fieldProps} stepProp={step}/>
		</NumberContainer>
	)
}

NumberComponent.propTypes = {
	field: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.array
	]),
	withControls: PropTypes.bool,
	noForm: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // provide value if 'noForm' is true
	onChange: PropTypes.func, // provide change handler if 'noForm' is true
	step: PropTypes.number,
	format: PropTypes.oneOf(['percent', 'currency']),
	precision: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]), // decimal precision
	enableNegative: PropTypes.bool,
	placeholder: PropTypes.string,
	label: PropTypes.string,
	inline: PropTypes.bool,
	withLocale: PropTypes.bool
}

NumberComponent.defaultProps = {
	withControls: true,
	type: 'text',
	withLocale: true
	// precision: 0 // default value is setted in NumberField to not override previously setted 'precision'
}

export default NumberComponent
